<template>
  <dx-scroll-view height="100%" width="100%" class="single-card">
     <div class="single-card-wrapper">
       <div class="dx-card content">
        <slot />
       </div>
       <div class="single-card-tagline">&copy; 2026 Tumai Cloud - Infrastructure for AI-Native Enterprises</div>
     </div>
  </dx-scroll-view>
</template>

<script>
import DxScrollView from "devextreme-vue/scroll-view";

export default {
  components: {
    DxScrollView
  }
};
</script>

<style lang="scss">
.single-card {
  width: 100%;
  height: 100%;

  /* Force all DX ScrollView inner wrappers to pass through 100% height */
  .dx-scrollable-wrapper,
  .dx-scrollable-container,
  .dx-scrollable-content,
  .dx-scrollview-content {
    height: 100% !important;
    min-height: 100% !important;
  }

  .dx-scrollview-content {
    display: flex !important;
    flex-direction: column !important;
  }

  .single-card-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 40px 0;
  }

  .dx-card {
    width: 400px;
    max-width: calc(100% - 80px);
    margin: 0;
    padding: 40px;
    flex-grow: 0;

    .screen-x-small & {
      width: 100%;
      border-radius: 0;
      box-shadow: none;
      margin: 0;
      border: 0;
    }
  }

  .single-card-tagline {
    margin-top: 20px;
    font-size: 12px;
    color: var(--base-text-color-alpha-7);
    opacity: 0.6;
  }
}
</style>
